/* eslint-disable no-param-reassign, no-use-before-define */
import { createSlice } from "@reduxjs/toolkit";

import { withNamespace } from "../../constants/namespace";

const initialState = {
  email: "",
  name: "",
  phoneNumber: ""
};

const contactFormSlice = createSlice({
  name: withNamespace("contactForm"),
  initialState
});

export default contactFormSlice.reducer;
